import i18next from 'i18next'
import { Link } from 'react-router-dom'
import { formatDateTime } from '../../utils/general'
import { projectResponseFields } from '../response/project'
import { getAgentsViewData, getOwnersBuyerViewData } from './utils'

export const projectGeneralViewData = (data) => {
    const { t } = i18next

    return {
        general: [
            {
                id: projectResponseFields.ID,
                label: t('app.common.id'),
                value: data?.[projectResponseFields.INTERNAL_APP_ID],
            },
            {
                id: projectResponseFields.PROJECT_EXTERNAL_URL,
                label: t('app.common.project.projectExternalUrl'),
                value: data?.[projectResponseFields.PROJECT_EXTERNAL_URL],
            },
            {
                id: `${projectResponseFields.PROJECT_STATUS}_name`,
                label: t('app.common.status'),
                value: data?.[projectResponseFields.PROJECT_STATUS]?.name,
            },
            {
                id: `${projectResponseFields.PROJECT_END_DATE}`,
                label: t('app.common.project.endDate'),
                value: formatDateTime(data?.[projectResponseFields.PROJECT_END_DATE]),
            },
            {
                id: projectResponseFields.PROJECT_RECEIPT_DATE,
                label: t('app.common.receiptDate'),
                value: formatDateTime(data?.[projectResponseFields.PROJECT_RECEIPT_DATE]),
            },
            {
                id: projectResponseFields.CONTRACT_NO,
                label: t('app.common.contractNumber'),
                value: data?.[projectResponseFields.CONTRACT_NO],
            },
            {
                id: projectResponseFields.CONTRACT_DATE,
                label: t('app.common.contractDate'),
                value: formatDateTime(data?.contractDate),
            },
            {
                id: projectResponseFields.CREATED,
                label: t('view.common.other.created'),
                value: formatDateTime(data?.[projectResponseFields.CREATED]),
            },
            {
                id: projectResponseFields.UPDATED,
                label: t('app.common.updated'),
                value: formatDateTime(data?.[projectResponseFields.UPDATED]),
            },
        ],
        location: [
            {
                id: projectResponseFields.COUNTRY,
                label: t('app.common.country'),
                value: data?.[projectResponseFields.COUNTRY]?.name,
            },
            {
                id: projectResponseFields.COUNTY,
                label: t('app.common.county'),
                value: data?.[projectResponseFields.COUNTY]?.name,
            },
            {
                id: projectResponseFields.CITY,
                label: t('app.common.cityMunicipality'),
                value: data?.[projectResponseFields.CITY]?.name,
            },
            {
                id: projectResponseFields.WIDER_AREA,
                label: t('app.common.widerArea'),
                value: data?.[projectResponseFields.WIDER_AREA]?.name,
            },
            {
                id: projectResponseFields.QUARTER,
                label: t('app.common.quarter'),
                value: data?.[projectResponseFields.QUARTER]?.name,
            },
            {
                id: projectResponseFields.ISLAND,
                label: t('app.common.island'),
                value: data?.[projectResponseFields.ISLAND]?.name,
            },
            {
                id: `${projectResponseFields.STREET}-${projectResponseFields.STREET_NUMBER}`,
                label: t('view.common.location.street'),
                value: data?.[projectResponseFields.STREET]
                    ? `${data?.[projectResponseFields.STREET] ?? ''} ${data?.[projectResponseFields.STREET_NUMBER] ?? ''}`
                    : null,
                icon: data?.[projectResponseFields.STREET_SYNC] ? <i className={`ms-1 text-success mdi mdi-check-circle fs-16`}></i> : null,
            },
        ],
        owners: getOwnersBuyerViewData(data?.[projectResponseFields.OWNER]),
        details: [
            {
                id: projectResponseFields.PROJECT_TYPE,
                label: t('app.common.project.type'),
                value: data?.[projectResponseFields.PROJECT_TYPE]?.name,
            },
            {
                id: projectResponseFields.PROJECT_SUBTYPE,
                label: t('app.common.project.subtype'),
                value: data?.[projectResponseFields.PROJECT_SUBTYPE]?.name,
            },
            {
                id: projectResponseFields.PROJECT_ENERGY_EFFICIENCY,
                label: t('app.common.energyEfficiency'),
                value: data?.[projectResponseFields.PROJECT_ENERGY_EFFICIENCY]?.name,
            },
            {
                id: projectResponseFields.PROJECT_WEB_SYNC,
                label: t('app.common.project.webSync'),
                value: data?.[projectResponseFields.PROJECT_WEB_SYNC] ? t('view.common.conclusion.yes') : t('view.common.conclusion.no'),
            },
        ],
        other: [
            ...getAgentsViewData(data?.[projectResponseFields.AGENT]),
            {
                id: projectResponseFields.UPDATED,
                label: t('app.common.updated'),
                value: formatDateTime(data?.[projectResponseFields.UPDATED], true),
            },
        ],
    }
}

export const projectQuickViewData = (data) => {
    const { t } = i18next

    return [
        {
            id: `${projectResponseFields.ID}_name`,
            label: t('app.common.projectId'),
            value: (
                // internalAppId is shown in link, but route uses id
                <Link className="dmn-link" to={`/projects/${data?.[projectResponseFields.ID]}`} target="_blank" rel="noopener noreferrer">
                    {data?.[projectResponseFields.INTERNAL_APP_ID]}
                </Link>
            ),
        },
        {
            id: `${projectResponseFields.PROJECT_STATUS}_name`,
            label: t('app.common.status'),
            value: data?.[projectResponseFields.PROJECT_STATUS]?.name,
        },
        {
            id: `${projectResponseFields.PROJECT_TITLE}_name`,
            label: t('app.common.project.title'),
            value: data?.[projectResponseFields.PROJECT_TITLE]?.name,
        },
        {
            id: `project_location`,
            label: t('app.common.location'),
            value: (
                <>
                    {data?.[projectResponseFields.CITY] || data?.[projectResponseFields.WIDER_AREA] ? (
                        <div>
                            {data?.[projectResponseFields.CITY] ? `${data?.[projectResponseFields.CITY]?.name},` : ''}{' '}
                            {data?.[projectResponseFields.WIDER_AREA] ? `${data?.[projectResponseFields.WIDER_AREA]?.name}` : ''}
                        </div>
                    ) : null}
                    {}
                    {data?.[projectResponseFields.QUARTER] ? <div>{data?.[projectResponseFields.QUARTER]?.name}</div> : ''}
                    {data?.[projectResponseFields.STREET] ? <div>{data?.[projectResponseFields.STREET]}</div> : ''}
                </>
            ),
        },
        {
            id: `${projectResponseFields.AGENT}_name`,
            label: t('app.common.agent'),
            value: (
                <>
                    {data?.[projectResponseFields.AGENT]?.[0]?.firstName} {data?.[projectResponseFields.AGENT]?.[0]?.lastName}
                </>
            ),
        },
        {
            id: `${projectResponseFields.PROJECT_END_DATE}_name`,
            label: t('app.common.project.endDate'),
            value: formatDateTime(data?.[projectResponseFields.PROJECT_END_DATE]),
        },
    ]
}
